import React, { useEffect, useRef, useState } from "react";
import { getDomainConfig } from "../../config/config";
import { subscribe, publish } from "../../utils/events";

const EmailAutocomplete = (props) => {

  const [emailPrefix, setEmailPrefix] = useState('');
  const [selectedItem, setSelectedItem] = useState(0);
  const [showEmailList, setShowEmailList] = useState(false);
  const [filteredDomains, setFilteredDomains] = useState([])

  const ulRef = useRef('');

  // most popular domains from user input data
  const domains = [
    'aol.co.uk',
    'aol.com',
    'arcor.de',
    'blueyonder.co.uk',
    'btconnect.com',
    'btinternet.com',
    'btopenworld.com',
    'comcast.net',
    'eircom.net',
    'freenet.de',
    'fsmail.net',
    'gmail.com',
    'gmail.co',
    'googlemail.com',
    'gmx.at',
    'gmx.de',
    'gmx.net',
    'hotmail.co.uk',
    'hotmail.com',
    'hotmail.de',
    'icloud.com',
    'live.co.uk',
    'live.com',
    'live.ie',
    'mac.com',
    'mail.com',
    'me.com',
    'msn.com',
    'nhs.net',
    'ntlworld.com',
    'outlook.com',
    'rocketmail.com',
    'sky.com',
    'talk21.com',
    'talktalk.net',
    'tesco.net',
    't-online.de',
    'tiscali.co.uk',
    'virgin.net',
    'virginmedia.com',
    'web.de',
    'yahoo.co.uk',
    'yahoo.com',
    'yahoo.de',
    'yahoo.ie',
    'ymail.com'
  ];

  const config = getDomainConfig();

  /* LOADING THE BRANDED SCSS */
  const [styles, setStyles] = useState(false);

  useEffect(() => {
  const getStyles = async (theFileName, theFileEnd) => {
    if (config.brand) {
      let moduleStyles = false;
      try {
        moduleStyles = await import(
          "./" + theFileName + config.brand + theFileEnd
        );
        setStyles(moduleStyles);
      } catch (e) {
        console.error(
          `Styles for ${theFileName} could not be loaded, ${e.message}`
        );
      }
    }
  };

    // Specify file name and end of file name here.
    getStyles("EmailAutocomplete", ".module.scss");
  }, [config.brand]);

  subscribe(props.context, "onChange", (event) =>{
    handleChange(event.detail)
  });

  subscribe(props.context, "onKeyUp", (event) =>{
    handleKeyUp(event.detail)
  });

  const handleChange = (event) => {
    const value = event.target.value;
    const atIndex = value.indexOf("@");

    if (atIndex !== -1) {
      const prefix = value.slice(0, atIndex);
      const domainInput = value.slice(atIndex + 1).toLowerCase();

      setEmailPrefix(prefix);

      if (domainInput.length > 0) {
        const filtered = domains.filter(domain => domain.startsWith(domainInput));
        if (filtered.length > 0) {
          setFilteredDomains(filtered);
          setShowEmailList(true);
          return;
        }
      }
      setFilteredDomains([]);
      setShowEmailList(false);
    }
  };

  const selectItem = (key) => {
    if (ulRef.current && ulRef.current.children[key]) {
      setSelectedItem(key);
      publish(props.context, "newValue", ulRef.current.children[key].innerText);
    }
  };

  const applySelectedDomain = (selectedItem) => {
    const selectedDomain = filteredDomains[selectedItem];
    const newEmail = `${emailPrefix}@${selectedDomain}`;

    publish(props.context, "updateTextfield", newEmail);
    setShowEmailList(false);
  }

  const handleKeyUp = (event) => {
    const key = event.key;

    if (!showEmailList || filteredDomains.length === 0) {
      return;
    }
    const domainListStartIndex = 0;
    let domainListEndIndex = filteredDomains.length -1;

    switch (key) {
      case 'ArrowDown':
        if (filteredDomains.length === 1) {
          selectItem(0);
        } else if (selectedItem < domainListEndIndex) {
          selectItem(selectedItem + 1);
        }
        break;
      case 'ArrowUp':
        if (selectedItem > domainListStartIndex) {
          selectItem(selectedItem - 1);
        }
        break;
      case 'Enter':
        if (filteredDomains.length > 0) {
          applySelectedDomain(selectedItem);
          selectItem(0);
        }
        break;
      case 'Escape':
        setShowEmailList(false);
        selectItem(0);
        break;
      default:
    }
  };

  return (
    <div data-testid="emailAutocomplete" className={styles.emailAutocompleteWrapper}>
      {showEmailList &&
      <div className={styles.domainListWrapper}>
        <ul ref={ulRef} className={styles.domainList}>
          {filteredDomains.map((domain, key) => {
            return <li data-dd-privacy="mask" key={key} data-key={key} className={`domainListItem ${key === selectedItem ? styles.selected : ""} `}
              onClick={() => {
                applySelectedDomain(key)
              }
            }
            >{emailPrefix}@<strong className={styles.domain}>{domain}</strong></li>
          })}
        </ul>
      </div>
    }
    </div>
  )
}

export default EmailAutocomplete;